import { Components } from "@mui/material/styles"

const Base = (): Components => {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        "@global": {
          "*": {
            margin: 0,
            padding: 0,
            boxSizing: "border-box",
          },
          html: {
            "@media (max-width: 1080px)": {
              fontSize: "93.75%",
            },
            "@media (max-width: 720px)": {
              fontSize: "87.5%",
            },
          },
          body: {
            "-webkit-font-smoothing": "antialiased",
          },
        },
      },
    },
  }
}

export default Base
